export const painPoints: string[] = [
  'Hours spent searching for diagrams, technical explanations and activities',
  'Repeating the same lessons because they are already prepared',
  'Technical topics that become harder to explain than they need to be',
  'Workshop activities without a consistent structure',
  'Students memorizing components without understanding how systems interact',
  'Assessments that need to be created again and again',
  'Lessons that feel disconnected from one topic to the next',
  'More time preparing and less time actually teaching',
  'Walking into class with information instead of a complete lesson',
]
